import { DEAL_PLACEHOLDER_IMG, DEAL_LISTING_TYPE } from '@/constants/global';

export default (dealProp) => ({
  computed: {
    categoryLink() {
      const group = this[dealProp]?.taxonomy?.group?.value_enumeration;
      const category = this[dealProp]?.taxonomy?.category?.value_enumeration;
      const subcategory = this[dealProp]?.taxonomy?.subcategory?.value_enumeration;

      return (group && category && subcategory) ? `/${group}/${category}/${subcategory}/` : '';
    },
    categoryName() {
      return this[dealProp]?.taxonomy?.subcategory?.search_values?.[0] || '';
    },
    dealCategory() {
      return this[dealProp]?.attributes?.filter((a) => a.slug === 'category');
    },
    dealUrl() {
      return this[dealProp] ? `${this[dealProp].get_absolute_url}?ref=best-match` : '';
    },
    isLastCallBuyState() {
      return this.deal?.buy_button?.is_last_call || false;
    },
    isEndedDeal() {
      return this[dealProp]?.browse_deal_status === 'expired';
    },
    isOriginals() {
      return this[dealProp]?.listing_type === DEAL_LISTING_TYPE.ORIGINAL;
    },
    isSelect() {
      return this[dealProp]?.listing_type === DEAL_LISTING_TYPE.SELECT;
    },
    isPlusExclusive() {
      return this[dealProp]?.listing_type === DEAL_LISTING_TYPE.PLUS_EXCLUSIVE;
    },
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    planType() {
      return this[dealProp]?.default_plan?.plan_type;
    },
    pricingText() {
      if (this[dealProp]?.is_free) {
        return 'FREE';
      }

      return `$${this[dealProp]?.default_plan?.price}`;
    },
    showPlanType() {
      return !!this.planType && !this[dealProp]?.is_free;
    },
    userHasPlus() {
      return this.$store.state?.session?.user?.has_plus;
    },
  },
});
